var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bread",staticStyle:{"min-width":"1066px"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.paths),function(item,ind){return _c('el-breadcrumb-item',[_vm._v(_vm._s(item))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }